<template>
  <div>
    <div class="chat-overlay" v-if="visible" @click="hide">
      <div class="chat-container" @click.stop>
        <div class="chat-header">
          <span class="chat-title">聊天</span>
          <div class="header-buttons">
            <button class="minimize-btn" @click="minimize" title="最小化">
              <i class="el-icon-minus"></i>
            </button>
            <button class="close-btn" @click="hide" title="关闭">
              <i class="el-icon-close"></i>
            </button>
          </div>
        </div>
        <Chat></Chat>
        <user-info ref="userInfo"></user-info>
        <group-info ref="groupInfo"></group-info>
        <full-image ref="fullImage"></full-image>
        <preview-file ref="previewFile"></preview-file>
        <rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
        <rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from '@/view/Chat.vue';
import UserInfo from '@/components/common/UserInfo.vue';
import GroupInfo from '@/components/group/GroupInfo.vue';
import FullImage from '@/components/common/FullImage.vue';
import RtcPrivateVideo from '@/components/rtc/RtcPrivateVideo.vue';
import RtcGroupVideo from '@/components/rtc/RtcGroupVideo.vue';
import PreviewFile from '@/components/common/PreviewFile.vue';
import imHostMixin from '@/mixins/imHostMixin';

export default {
  name: 'ChatDialog',
  mixins: [imHostMixin],
  components: {
    Chat,
    UserInfo,
    PreviewFile,
    RtcGroupVideo,
    RtcPrivateVideo,
    FullImage,
    GroupInfo,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    imShouldSuppressNotification() {
      return this.visible;
    },
    show() {
      this.visible = true;
      this.imEnsureStarted();
    },
    hide() {
      this.visible = false;
    },
    minimize() {
      this.$eventBus.$emit('showMinimizedChat');
      this.hide();
    },
  },
  computed: {
    mine() {
      return this.userStore.userInfo;
    },
    unreadCount() {
      let count = 0;
      this.chatStore.conversations.forEach((conv) => {
        if (!conv.isDnd) {
          count += conv.unreadCount;
        }
      });
      return count;
    },
  },
  watch: {
    unreadCount: {
      handler(newCount) {
        const tip = newCount > 0 ? this.$t('home.nUnreadTitle', { n: newCount }) : '';
        this.$elm.setTitleTip(tip);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2015;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-container {
  width: 62vw;
  height: 80vh;
  min-height: 600px;
  min-width: 970px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: var(--im-box-shadow-dark);
  transition: 0.2s;
  z-index: 2016;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  > :deep(.chat-page) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.chat-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.header-buttons {
  display: flex;
  align-items: center;
}

.close-btn,
.minimize-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: #e0e0e0;
    color: #333;
  }

  &:active {
    transform: scale(0.95);
  }
}

.minimize-btn {
  margin-right: 5px;
}
</style>
